import { Button, Container, Paper, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/logoStudioPBADS.png";
import connectBackground from "../../assets/shattered-island.gif";
import OAuth from "./OAuth";
import ResponsiveDialogManager from "../dialog/ResponsiveDialogManager";
import AuthForms from "../forms/AuthForms";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useViewport } from "../../helpers";

const PREFIX = "AuthDialog";

const classes = {
  root: `${PREFIX}-root`,
  logo: `${PREFIX}-logo`,
  buttonConnectContainer: `${PREFIX}-buttonConnectContainer`,
  connectbuttons: `${PREFIX}-connectbuttons`,
};

const AuthDialogContainer = styled("div")(({ theme }) => ({
  [`& .${classes.root}`]: {
    backgroundImage: `url(${connectBackground})`,
    // minHeight: "70vh",
    borderRadius: 0,
    padding: "2rem 2rem 2rem 2rem",
  },

  [`& .${classes.logo}`]: {
    width: "100%",
    maxWidth: "70vh",
    padding: "1rem",
    position: "relative",
    left: "50%",
    transform: "translateX(-50%)",
  },

  [`& .${classes.buttonConnectContainer}`]: {
    textAlign: "center",
  },

  [`& .${classes.connectbuttons}`]: {
    alignItems: "center",
    margin: "1rem",
    borderRadius: "20px",
  },
}));

const AuthDialog = ({ origin = "", exparienceID, setLoginModal }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { width } = useViewport();

  const [isLogin, setIsLogin] = useState(false);
  const [isRegistration, setIsRegistration] = useState(false);
  const [isRecovery, setIsRecovery] = useState(false);

  const handleClickOpen = (formName) => {
    if (formName === "login") {
      setIsLogin(true);
    } else {
      setIsRegistration(true);
    }
  };

  const handleClose = (value) => {
    setIsLogin(false);
    setIsRegistration(false);
    setIsRecovery(false);
  };

  useEffect(() => {
    setIsLogin(
      location.state && location.state.hasOwnProperty("isLoginRequested")
        ? location.state.isLoginRequested
        : false
    );
    if (window.location.pathname === "/login") {
      setIsLogin(true);
    } else if (window.location.pathname === "/register") {
      setIsRegistration(true);
    }
  }, []);

  return (
    <AuthDialogContainer>
      <Paper
        className={classes.root}
        square
        sx={{ height: origin === "purchaseGeoloc" ? "80vh" : "100vh" }}
      >
        <div>
          <img src={Logo} className={classes.logo} alt="Logo" />
        </div>
        <Typography
          variant={origin === "purchaseGeoloc" ? "h4" : "h3"}
          gutterBottom
          align="center"
          sx={{
            width:
              origin === "purchaseGeoloc"
                ? width > 769
                  ? "450px"
                  : "250px"
                : "100%",
            margin: origin === "purchaseGeoloc" && "0 auto",
            marginBottom: "45px",
          }}
        >
          {t("homePage.logginSection.welcomeSentence.welcomeOn")}
          <b>{t("homePage.logginSection.welcomeSentence.your")}</b>
          {t("homePage.logginSection.welcomeSentence.lifestyle")}
          <b>{t("homePage.logginSection.welcomeSentence.art")}</b>
          {t("homePage.logginSection.welcomeSentence.end")}
        </Typography>
        <Container className={classes.buttonConnectContainer}>
          <Button
            variant="contained"
            className={classes.connectbuttons}
            color="primary"
            onClick={() => handleClickOpen("login")}
          >
            {t("homePage.logginSection.login")}
          </Button>
          <Button
            variant="contained"
            className={classes.connectbuttons}
            color="primary"
            onClick={() => handleClickOpen("register")}
          >
            {t("homePage.logginSection.signin")}
          </Button>
          <OAuth />
          <ResponsiveDialogManager
            open={isLogin || isRegistration}
            renderer={
              <AuthForms
                handleCloseModal={handleClose}
                mode={isLogin ? "login" : "register"}
                setIsRecovery={setIsRecovery}
                origin={origin}
                exparienceID={exparienceID}
                setLoginModal={setLoginModal}
              />
            }
            title={
              isRecovery
                ? "Mot de passe oublié"
                : isLogin
                ? t("homePage.logginSection.login")
                : t("homePage.logginSection.signin")
            }
            onClose={handleClose}
          />
        </Container>
      </Paper>
    </AuthDialogContainer>
  );
};

export default AuthDialog;
